<!-- 
  通用位置选择组件
    1关于参数basemap
      1.1:仅谷歌底图选择位置 (basemap=normal)
      1.2:根据应用ID获取所有图层后 选择位置 (basemap=all)
      3.3:改革示范区底图选择位置 (basemap=ggsfq)
    2关于参数zrqlx：责任区类型，一般有：geo_grid_sheng/geo_grid_shi/geo_grid_xian/geo_grid_xiang/geo_grid_cun，分别对应五级责任区
    3关于参数zrqobjid:对应责任区的objid
-->
<template>
  <div class="dhmap-wrapper">
    <div id="selectmap"
         ref="selectmap" v-resize="resize"></div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex'
import 'ol/ol.css';
import { initMap, addLayerToMap, actLocate, mapalert, addGgsfqLayerToMap ,getLayerByType} from '@/utils/MapUtils'
import { Vector as VectorLayer } from 'ol/layer.js'
import VectorSource from 'ol/source/Vector.js'
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point'
import { locateStyleCollection } from '@/utils/MapIcons'
import { Style, Stroke } from 'ol/style.js';
export default {
  name: "map-selector",
  components: {},
  props: {
    param: { type: Object, default: () => { return {} } },
    cord: { type: Array, default: () => { return [] } },
    mode: { type: String, default: "web" }
  },
  model:{
    prop:'cord',
    event:'onselect'
  },
  data () {
    return {
      map: null,
      gisconfig: {},
      zrqVector: null,
      zrqSourceVector: null,
      zrqStyle: new Style({
        stroke: new Stroke({
          color: '#2a32fc',
          width: 5.5
        })
      }),
      selectVector: null,
      selectSourceVector: null
    }
  },
  mounted () {
    this.loadMap()
  },
  methods: {
    getPosition () {
      return this.map.getView().getCenter()
    },
    setPosition (x, y) {
      if (x > -180 && x < 180 && y > -90 && y < 90) {
        this.map.getView().animate({
          center: [x, y],
          duration: 500
        });
      }
    },
    loadMap () {
      var _this = this;
      if (_this.userinfo && _this.userinfo.appId) {
        this.$api.Mapapi.getconfig({
          'appId': _this.userinfo.appId,
        }).then(res => {
          if (res && res.code == 1) {
            _this.gisconfig = res.data
            //设置该地图根据CQL进行过滤加载
            _this.gisconfig.queryWithCQL = true
            //设置CQL进行查询，必须要提供uid、uregion、uregionlevel三个参数
            _this.gisconfig.uid = _this.userinfo.uid
            _this.gisconfig.uregion = _this.userinfo.zqCode
            _this.gisconfig.uregionlevel = [null, 1, 1, 2, 2, 3, 3, 4, 4, 4, 5, 5, 5, 5, 5][_this.gisconfig.uregion.length]
            //初始化地图
            if(this.mode == 'h5'){
              _this.map = initMap('selectmap',_this.gisconfig,{showZoom:false})
            }else{
              _this.map = initMap('selectmap',_this.gisconfig)
            }
            //如果 basemap 为all或ggsfq 需要根据gisconfig加载地图
            if (_this.param.basemap == 'all') {
              addLayerToMap(_this.map, _this.gisconfig,null,['tdtzj','geo_sheng','geo_shi','geo_xian','geo_xiang','geo_cun'])
              //getLayerByType(_this.map,'tdtzj').setVisible(true)
            } else if (_this.param.basemap == 'ggsfq') {
              addGgsfqLayerToMap(_this.map, _this.gisconfig)
            }
            _this.map.gisConfig = res.data
            //定义个Vector层
            _this.zrqSourceVector = new VectorSource()
            _this.zrqVector = new VectorLayer({
              source: _this.zrqSourceVector,
              style: function (feature) {
                return _this.zrqStyle
              }
            })
            _this.map.addLayer(_this.zrqVector)
            //高亮责任区
            // if (_this.param.zrqlx && _this.param.zrqobjid) {
            //   actLocate(_this.map, _this.param.zrqlx, _this.param.zrqobjid, _this.zrqVector)
            // }
            //地图定位中心点（以接受的参数为准）
            _this.map.getView().setZoom(15)
            if(_this.param.lon && _this.param.lat){
              _this.map.getView().setCenter([_this.param.lon * 1, _this.param.lat * 1]);
            }
            //初始化一个feature放在地图中心点，并设置该中心点的feature不跟随地图移动
            _this.initCenterPosition()
            _this.bindMapEvt()
          } else {
            mapalert(res.msg)
          }
        }).catch((err) => { mapalert('地图加载异常!') })
      }
    },
    resize(){
      var _this = this
      setTimeout( function() { _this.map && _this.map.updateSize();}, 200);
    },
    initCenterPosition () {
      // //定义个专用Vector层（用于放置一个永远不跟随地图移动的定位Symbol）
      this.selectSourceVector = new VectorSource()
      this.selectVector = new VectorLayer({
        source: this.selectSourceVector
      })
      this.map.addLayer(this.selectVector)
      //添加中心点Feature
      var centerFeature = new Feature(new Point(this.map.getView().getCenter()))
      centerFeature.setStyle(locateStyleCollection['default']);
      this.selectSourceVector.addFeature(centerFeature);

      //是中心点不跟随移动
      var _this = this
      _this.selectVector.on("postcompose", function (evt) {
        try{
          _this.selectSourceVector.clear();
          //拿到vectorContex对象，开始绘制
          var vCtx = evt.vectorContext
          var center = _this.map.getView().getCenter()
          var centerFeature = new Feature(new Point(center))
          vCtx.drawFeature(centerFeature, locateStyleCollection['default'])
        }catch(e){}
      })
    },
    bindMapEvt() {
      var _this = this
      this.map.on('moveend', function(evt) {
        var cur = _this.map.getView().getCenter()
        if (cur[0]) {
          let arr=[];
          arr.push(cur[0].toFixed(6))
          arr.push(cur[1].toFixed(6))
          _this.$emit('onselect',arr)
        }
        _this.param.lon = cur[0]
        _this.param.lat = cur[1]
      })
      this.map.on('pointermove', function(evt) {
        var cur = _this.map.getView().getCenter()
        _this.param.lon = cur[0]
        _this.param.lat = cur[1]
      })
      this.map.getView().on('change:resolution',function(evt){
        _this.map.getView().setCenter([_this.param.lon * 1, _this.param.lat * 1]);
      })
    },
  },
  computed: {
    ...mapState(['userinfo'])
  },
  watch: {
    userinfo () {
      this.loadMap()
    },
    cord(val){
      console.log("传递的位置===="+val)
      if(val && val.length == 2){
        this.param.lon = val[0]
        this.param.lat = val[1]
        this.setPosition(val[0],val[1])
      }
    }
  },
  directives: {  // 使用局部注册指令的方式
    resize: { // 指令的名称
      bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
        let width = '', height = '';
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value();  // 关键
          }
          width = style.width;
          height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__);
      }
    }
  }
}
</script>

<style scoped>
#selectmap {
  width: 100%;
  height: 100%;
}
</style>